/** Retained UTF-8 payload limits; Redis allocator/stream overhead is budgeted separately. */
export const CONSOLE_LOG_MAX_LINES = 500;
export const CONSOLE_LOG_MAX_BYTES = 1024 * 1024;
export const CONSOLE_LOG_LINE_MAX_BYTES = 4000;
export const CONSOLE_LOG_TRUNCATION_MARKER = "… [truncated]";
const encoder = new TextEncoder();
const markerBytes = encoder.encode(CONSOLE_LOG_TRUNCATION_MARKER).length;
function charBytes(char) {
    const code = char.codePointAt(0);
    return code <= 0x7f ? 1 : code <= 0x7ff ? 2 : code <= 0xffff ? 3 : 4;
}
/** Never splits a code point; replacement characters also count against the byte limit. */
export function boundConsoleLogLine(input) {
    const parts = [];
    let bytes = 0;
    for (const raw of input) {
        const code = raw.codePointAt(0);
        const char = code >= 0xd800 && code <= 0xdfff ? "�" : raw === "\0" ? "�" : raw;
        const size = charBytes(char);
        if (bytes + size > CONSOLE_LOG_LINE_MAX_BYTES) {
            while (bytes > CONSOLE_LOG_LINE_MAX_BYTES - markerBytes) {
                bytes -= encoder.encode(parts.pop()).length;
            }
            return parts.join("") + CONSOLE_LOG_TRUNCATION_MARKER;
        }
        parts.push(char);
        bytes += size;
    }
    return parts.join("");
}
/** Latest logical lines, bounded before constructing a joined batch or allocating split arrays. */
export function boundConsoleLogBatch(input) {
    const reversed = [];
    let bytes = 0;
    outer: for (let index = input.length - 1; index >= 0; index--) {
        const raw = input[index];
        // A malformed oversized caller cannot make newline splitting allocate without a bound.
        const clipped = raw.length > CONSOLE_LOG_MAX_BYTES;
        const text = clipped ? raw.slice(-CONSOLE_LOG_MAX_BYTES) : raw;
        let end = text.length;
        if (end > 0 && text[end - 1] === "\n") {
            end--;
        }
        do {
            const newline = end === 0 ? -1 : text.lastIndexOf("\n", end - 1);
            let value = text.slice(newline + 1, end).replace(/\r$/, "");
            if (clipped && newline < 0) {
                value = CONSOLE_LOG_TRUNCATION_MARKER + value;
            }
            const line = boundConsoleLogLine(value);
            const length = encoder.encode(line).length;
            if (bytes + length > CONSOLE_LOG_MAX_BYTES) {
                break outer;
            }
            reversed.push(line);
            bytes += length;
            if (reversed.length === CONSOLE_LOG_MAX_LINES || newline < 0) {
                break;
            }
            end = newline;
        } while (end >= 0);
        if (reversed.length === CONSOLE_LOG_MAX_LINES) {
            break;
        }
    }
    return reversed.reverse();
}
